export default __webpack_public_path__ + "428978dc7837d46de0916f266f5a43df.woff";